module.exports = __webpack_public_path__ + "img/caroussel.81410c32.jpg";